import React from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxField, InputField } from "ui/control/field";
import {
    richTextEditorDialog,
    RichTextEditorDialogProps
} from "ui/control/richtexteditor/dialog/rich-text-editor-dialog";

export interface RichTextCopyImageValues {
    url?: string;
    compress?: boolean;
}

type Props = {
    compressDefault?: boolean;
} & RichTextEditorDialogProps<RichTextCopyImageValues>;

const mapPropsToValues = (props: Props): RichTextCopyImageValues => ({
    url: "",
    compress: props.compressDefault ?? true,
});

const RichTextCopyImageDialog = () => {
    const {t} = useTranslation();

    return (
        <>
            <InputField type="url" name="url" title={t("link")} autoFocus/>
            <CheckboxField title={t("compress-images-video")} name="compress"/>
        </>
    );
}

export default richTextEditorDialog<Props, RichTextCopyImageValues>(
    "copy-image-video-from-internet", mapPropsToValues, RichTextCopyImageDialog
);
